var DependencyType;

(function (DependencyType) {
  DependencyType["UNSENT"] = "UNSENT";
  DependencyType["STATIC"] = "STATIC";
  DependencyType["COLLAGE"] = "COLLAGE";
  DependencyType["STICKY"] = "STICKY";
})(DependencyType || (DependencyType = {}));

var LayerType;

(function (LayerType) {
  LayerType["IMAGE_LAYER"] = "IMAGE_LAYER";
  LayerType["COLOR_LAYER"] = "COLOR_LAYER";
  LayerType["TEXT_LAYER"] = "TEXT_LAYER";
  LayerType["GROUP_LAYER"] = "GROUP_LAYER";
  LayerType["VECTOR_LAYER"] = "VECTOR_LAYER";
})(LayerType || (LayerType = {}));

var KnownErrors;

(function (KnownErrors) {
  KnownErrors[KnownErrors["cancelPipeline"] = 0] = "cancelPipeline";
  KnownErrors[KnownErrors["removedImage"] = 1] = "removedImage";
})(KnownErrors || (KnownErrors = {}));

var SettingsType;

(function (SettingsType) {
  SettingsType["NUMERIC"] = "NUMERIC";
  SettingsType["ENUM"] = "ENUM";
  SettingsType["BOOLEAN"] = "BOOLEAN";
  SettingsType["COLOR"] = "COLOR";
  SettingsType["POINT"] = "POINT";
})(SettingsType || (SettingsType = {}));

var LayerEvent;

(function (LayerEvent) {
  LayerEvent["READY"] = "READY";
  LayerEvent["UPDATE"] = "UPDATE";
  LayerEvent["READY_WITH_CHILDREN"] = "READY_WITH_CHILDREN";
})(LayerEvent || (LayerEvent = {}));

export { DependencyType as D, KnownErrors as K, LayerType as L, SettingsType as S, LayerEvent as a };
